import { useSWRConfig } from "swr"

const useClearSWR = (): {
    clearCache: () => Promise<void>
} => {
    const { mutate, cache } = useSWRConfig()

    const clearCache = async (): Promise<void> => {
        // Check if cache.keys() exists and is iterable
        if (cache && typeof cache.keys === "function") {
            let cacheKeys: string[] = []
            try {
                // Try the normal Array.from approach
                cacheKeys = Array.from(cache.keys() as Iterable<string>)
            } catch (error) {
                // Fallback for test environments
                // eslint-disable-next-line no-console
                console.warn(
                    "Failed to convert cache keys to array, using workaround"
                )
                // Use a safer approach
                if (cache.keys()) {
                    const iterator = cache.keys() as IterableIterator<string>
                    let result = iterator.next()
                    while (!result.done) {
                        cacheKeys.push(result.value)
                        result = iterator.next()
                    }
                }
            }

            await Promise.all(
                cacheKeys.map((key) =>
                    mutate(key, undefined, { revalidate: false })
                )
            )
        }
    }

    return { clearCache }
}

export default useClearSWR
